import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ImageDropzone from '../ImageDropzone/ImageDropzone';
export function NodeTypeModalForm({ isOpen, onClose, onSubmit, isLoading, mode, nodeType, title, submitIdleLabel, submitBusyLabel }) {
    const [name, setName] = useState('');
    const [image, setImage] = useState(null);
    const [nameError, setNameError] = useState('');
    // Reset (create) or populate (edit) the form state every time the modal opens
    useEffect(() => {
        if (!isOpen)
            return;
        if (mode === 'edit') {
            if (!nodeType)
                return;
            setName(nodeType.name);
            setImage(nodeType.image);
        }
        else {
            setName('');
            setImage(null);
        }
        setNameError('');
    }, [isOpen, nodeType, mode]);
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name.trim()) {
            setNameError('Name is required');
            return;
        }
        onSubmit({ name: name.trim(), image });
    };
    const handleClose = () => {
        onClose();
    };
    if (!isOpen || (mode === 'edit' && !nodeType))
        return null;
    return (_jsx("div", { className: "modal-overlay", onClick: handleClose, children: _jsxs("div", { className: "modal-content", onClick: e => e.stopPropagation(), children: [_jsxs("div", { className: "modal-header", children: [_jsx("h2", { children: title }), _jsx("button", { className: "close-button", onClick: handleClose, disabled: isLoading, children: "\u00D7" })] }), _jsxs("form", { onSubmit: handleSubmit, className: "modal-form", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "nodeTypeName", children: "Name" }), _jsx("input", { id: "nodeTypeName", value: name, onChange: e => { setName(e.target.value); if (nameError)
                                        setNameError(''); }, disabled: isLoading, className: nameError ? 'error' : '' }), nameError && _jsx("span", { className: "error-text", children: nameError })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Image" }), _jsx(ImageDropzone, { currentImageUrl: image, onUploadSuccess: setImage })] }), _jsxs("div", { className: "modal-actions", children: [_jsx("button", { type: "button", onClick: handleClose, disabled: isLoading, children: "Cancel" }), _jsx("button", { type: "submit", disabled: isLoading || !name.trim(), children: isLoading ? submitBusyLabel : submitIdleLabel })] })] })] }) }));
}
